import FeedBackConstant from "../Constants/FeedBackConstants";
import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";

class FeedBack_Action {
  getFeedBackByEqGrp(userID) {
    httpRequest(
      config.webServiceURL +
        "/VorlageManagement/rueckmeldungsvorlage?anlagegruppeId=" +
        userID,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: FeedBackConstant.GET_FEEDBACK_LIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: FeedBackConstant.GET_FEEDBACK_LIST_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  saveUpdateFeedBack(feedBackData) {
    httpRequest(
      config.webServiceURL + "/VorlageManagement/createrueckmeldungvorlage",
      "PUT",
      JSON.stringify({
        Id: feedBackData.ID,
        Bezeichnung: feedBackData.Bezeichnung,
        AnlagegruppeId: feedBackData.eqID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: FeedBackConstant.SAVE_UPDATE_FEEDBACK_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: FeedBackConstant.SAVE_UPDATE_FEEDBACK_FAILURE,
            result: message,
          });
        }
      }
    );
  }
  deleteFeedBack(feedBackId, equGrpId) {
    httpRequest(
      config.webServiceURL +
        "/VorlageManagement/deleterueckmeldungvorlage/" +
        equGrpId,
      "DELETE",
      JSON.stringify([...feedBackId]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: FeedBackConstant.DEL_FEEDBACK_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: FeedBackConstant.DEL_FEEDBACK_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new FeedBack_Action();
